import { createFileRoute } from "@tanstack/react-router";
import { TransactionsTable, validateTransactionsSearch } from "./-transactions-table";

// Real implementation of Task 30 Part D, replacing the Task-22 placeholder:
// all on-chain transactions across every merchant (TECH_VIEWER-gated). Thin
// wrapper around the shared `-transactions-table.tsx` (also used by
// `_app.unmatched-deposits.tsx`) — see that file for the table, filters, and
// row-detail dialog with the RBF replacement chain.
export const Route = createFileRoute("/_app/transactions")({
  validateSearch: validateTransactionsSearch,
  component: TransactionsPage,
});

function TransactionsPage() {
  return <TransactionsTable lockedToUnmatched={false} />;
}
